
import { granjaApi } from "../../api";
import { useLotesStore } from "../../store";

import Swal from "sweetalert2";







export const startLoteXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/lote/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}



export const startListadoLotes = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        const { data } = await granjaApi.get('/lote', { params });
        useLotesStore.setState({ totalLote: data.total });

        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const lotesXGranja = async( id ) => {
    try {
        const { data } = await granjaApi.get(`/lote/xgranja/${id}`);
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error);
    }
}




export const startSavingLotes = async(lote) => {
    try {
        if( lote.id ){
            await granjaApi.put(`/lote/${ lote.id }`, lote );
            Swal.fire('Exitoso', 'Lote Actualizado', 'success');
        }else {
            await granjaApi.post('/lote/new', lote);
            Swal.fire('Exitoso', 'Lote Creado', 'success');
            return true;
        }
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
} 

    



    // const deleteGranja = async( granja ) => {
    //     try {
    //         const { data } = await granjaApi.delete(`/granja/${ granja.id }`);
    //         if( data.ok ){
    //             dispatch( onDeleteGranja( data.granja ) );
    //             Swal.fire('Exitoso', 'Granja Eliminada', 'success');
    //         }
    //     } catch (error) {
    //         Swal.fire('Error', error.response.data.msg, 'error');
    //         console.log(error);
    //     }
    // }